<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="48"
    height="48"
    viewBox="0 0 48 48"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M6.1005 28.1005C8.72601 25.475 12.287 24 16 24C19.713 24 23.274 25.475 25.8995 28.1005C28.525 30.726 30 34.287 30 38C30 39.1046 29.1046 40 28 40C26.8954 40 26 39.1046 26 38C26 35.3478 24.9464 32.8043 23.0711 30.9289C21.1957 29.0536 18.6522 28 16 28C13.3478 28 10.8043 29.0536 8.92893 30.9289C7.05357 32.8043 6 35.3478 6 38C6 39.1046 5.10457 40 4 40C2.89543 40 2 39.1046 2 38C2 34.287 3.475 30.726 6.1005 28.1005Z"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M16 12C12.6863 12 10 14.6863 10 18C10 21.3137 12.6863 24 16 24C19.3137 24 22 21.3137 22 18C22 14.6863 19.3137 12 16 12ZM6 18C6 12.4772 10.4772 8 16 8C21.5228 8 26 12.4772 26 18C26 23.5228 21.5228 28 16 28C10.4772 28 6 23.5228 6 18Z"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M30 10C30 8.89543 30.8954 8 32 8C34.6522 8 37.1957 9.05357 39.0711 10.9289C40.9464 12.8043 42 15.3478 42 18C42 20.6522 40.9464 23.1957 39.0711 25.0711C38.8867 25.2554 38.696 25.4318 38.4993 25.6C39.7414 26.251 40.8896 27.0906 41.8995 28.1005C44.525 30.726 46 34.287 46 38C46 39.1046 45.1046 40 44 40C42.8954 40 42 39.1046 42 38C42 35.3478 40.9464 32.8043 39.0711 30.9289C37.1957 29.0536 34.6522 28 32 28C30.8954 28 30 27.1046 30 26C30 24.8954 30.8954 24 32 24C33.5913 24 35.1174 23.3679 36.2426 22.2426C37.3679 21.1174 38 19.5913 38 18C38 16.4087 37.3679 14.8826 36.2426 13.7574C35.1174 12.6321 33.5913 12 32 12C30.8954 12 30 11.1046 30 10Z"
    />
  </svg>
</template>
